import { FC } from 'react';
import { Comment } from 'app/modules/comments/types';
import CommentsHyperText from 'app/modules/posts/modules/post/components/postCommunication/comments/commentsList/CommentsHyperText';
import { useAnnotationInteraction } from 'app/modules/posts/modules/post/new/modules/annotations/components/AnnotationInteractionContext';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@kontentino/ui';
import useAnnotationDone from 'app/modules/posts/modules/post/components/postCommunication/comments/hooks/useAnnotationDone';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

interface Props {
  comment: Comment;
}

const CommentsListItemAnnotation: FC<Props> = ({ comment }) => {
  const { t } = useTranslation();
  const annotationInteraction = useAnnotationInteraction();
  const { markAsDone } = useAnnotationDone(comment);

  const annotation = comment.meta!.annotation!;
  const isDone = annotation.done === true;

  const isActive =
    annotationInteraction?.activeAnnotationText === annotation.selected_text;

  const handleClick = () => {
    annotationInteraction?.onAnnotationClick(annotation);
  };

  const handleMarkAsDone = (e: React.MouseEvent) => {
    e.stopPropagation();
    markAsDone();
  };

  return (
    <div
      onClick={handleClick}
      className={clsx('tw-flex tw-items-start tw-gap-2', {
        'tw-cursor-pointer tw-transition-opacity hover:tw-opacity-80':
          !!annotationInteraction,
      })}
      data-active={isActive || undefined}
    >
      <div
        className={clsx('tw-min-w-0 tw-flex-1', {
          'tw-line-through tw-opacity-50': isDone,
        })}
      >
        <CommentsHyperText
          isCurrentUser={false}
          colorVariant="primary"
          disableMentionStyle
          mentionedUsers={[]}
          options={{
            maxLength: 140,
            ellipsis: false,
          }}
        >
          {annotation.selected_text}
        </CommentsHyperText>
      </div>
      <Tooltip content={!isDone ? t('markAsDone') : undefined}>
        <button
          type="button"
          onClick={!isDone ? handleMarkAsDone : undefined}
          disabled={isDone}
          data-cy="annotation_mark-as-done"
          className={clsx(
            'tw-flex tw-flex-shrink-0 tw-items-center tw-justify-center tw-transition-colors',
            {
              'tw-text-grayscale-40 hover:tw-text-grayscale-100': !isDone,
              'tw-text-success-100': isDone,
            },
          )}
        >
          <FontAwesomeIcon icon={faCheck} className="tw-text-sm" />
        </button>
      </Tooltip>
    </div>
  );
};

export default CommentsListItemAnnotation;
